
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/works/photographs",
      function () {
        return require("private-next-pages/works/photographs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/works/photographs"])
      });
    }
  